export default __webpack_public_path__ + "static/media/ART16.ffac4c3b.jpg";